/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI BMAW
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FeatureTileDto,
  FeatureTilesReorderRequest,
  SmartProblemDetails,
} from '../models/index';
import {
    FeatureTileDtoFromJSON,
    FeatureTileDtoToJSON,
    FeatureTilesReorderRequestFromJSON,
    FeatureTilesReorderRequestToJSON,
    SmartProblemDetailsFromJSON,
    SmartProblemDetailsToJSON,
} from '../models/index';

export interface FeatureTilesCreateTilePostRequest {
    featureTileDto?: FeatureTileDto;
}

export interface FeatureTilesDeleteTileRequest {
    id: string;
}

export interface FeatureTilesReorderTilesPostRequest {
    featureTilesReorderRequest?: FeatureTilesReorderRequest;
}

export interface FeatureTilesUpdateTilePutRequest {
    id: string;
    featureTileDto?: FeatureTileDto;
}

/**
 * 
 */
export class FeatureTilesApi extends runtime.BaseAPI {

    /**
     */
    async featureTilesCreateTilePostRaw(requestParameters: FeatureTilesCreateTilePostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureTileDto>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/FeatureTiles`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FeatureTileDtoToJSON(requestParameters['featureTileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureTileDtoFromJSON(jsonValue));
    }

    /**
     */
    async featureTilesCreateTilePost(requestParameters: FeatureTilesCreateTilePostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureTileDto> {
        const response = await this.featureTilesCreateTilePostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async featureTilesDeleteTileRaw(requestParameters: FeatureTilesDeleteTileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling featureTilesDeleteTile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/FeatureTiles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featureTilesDeleteTile(requestParameters: FeatureTilesDeleteTileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.featureTilesDeleteTileRaw(requestParameters, initOverrides);
    }

    /**
     */
    async featureTilesGetAllCustomTilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureTileDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/FeatureTiles/admin`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureTileDtoFromJSON));
    }

    /**
     */
    async featureTilesGetAllCustomTiles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureTileDto>> {
        const response = await this.featureTilesGetAllCustomTilesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async featureTilesGetPortalTilesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FeatureTileDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/FeatureTiles/custom`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FeatureTileDtoFromJSON));
    }

    /**
     */
    async featureTilesGetPortalTiles(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FeatureTileDto>> {
        const response = await this.featureTilesGetPortalTilesRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async featureTilesReorderTilesPostRaw(requestParameters: FeatureTilesReorderTilesPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/FeatureTiles/reorder`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FeatureTilesReorderRequestToJSON(requestParameters['featureTilesReorderRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featureTilesReorderTilesPost(requestParameters: FeatureTilesReorderTilesPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.featureTilesReorderTilesPostRaw(requestParameters, initOverrides);
    }

    /**
     */
    async featureTilesUpdateTilePutRaw(requestParameters: FeatureTilesUpdateTilePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureTileDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling featureTilesUpdateTilePut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["api://40740436-0f46-43d8-86f5-e2cb999feec6/access_as_user"]);
        }


        let urlPath = `/api/FeatureTiles/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FeatureTileDtoToJSON(requestParameters['featureTileDto']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureTileDtoFromJSON(jsonValue));
    }

    /**
     */
    async featureTilesUpdateTilePut(requestParameters: FeatureTilesUpdateTilePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureTileDto> {
        const response = await this.featureTilesUpdateTilePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
